// Utility function to update favicon with emoji
export const updateFavicon = (emoji) => {
  if (!emoji) {
    // Reset to default favicon if no emoji
    resetFavicon();
    return;
  }

  // Create SVG data URL with the emoji
  const svgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="90">${emoji}</text></svg>`;
  const encodedSvg = encodeURIComponent(svgString);
  const dataUrl = `data:image/svg+xml,${encodedSvg}`;

  // Update the favicon
  updateFaviconHref(dataUrl);
};

// Reset to default favicon
export const resetFavicon = () => {
  updateFaviconHref('/favicon.ico');
};

// Helper function to update favicon href
const updateFaviconHref = (href) => {
  // Remove existing favicon links
  const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
  existingFavicons.forEach(link => link.remove());

  // Create new favicon link
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = href;
  link.type = href.startsWith('data:') ? 'image/svg+xml' : 'image/x-icon';
  
  document.head.appendChild(link);
};
